import { styled as t } from "styled-components";
import { Colors as o } from "../../../styles/colors/index.js";
import { Caption as r } from "../../../styles/typography/index.js";
import { SmartLink as i } from "../../../components/SmartLink/index.js";
import { Button as n } from "../../../components/Button/index.js";
import { MediaQuery as e } from "../../../styles/variables.js";
const s = t.div`
  position: relative;
  width: 100%;
  background-color: rgb(${o.White});
  border-radius: 4px;
  padding: 5px 16px;
  display: flex;
  flex-direction: column;

  &:after {
    position: absolute;
    content: '';
    top: 0px;
    left: 0px;
    width: 6px;
    height: 100%;
    background-color: rgb(${o.Yellow});
    border-radius: 4px 0 0 4px;
  }
`, f = t.div`
  ${r}
  color: rgb(${o.Gray});
`, x = t(i)`
  ${r}
  color: rgb(${o.Blue});
  width: fit-content;
`, g = t(n)`
  width: 100%;
  margin-top: 12px;

  @media ${e.SCREEN_MD_UP} {
    width: fit-content;
  }
`;
export {
  g as ContactPelandoButton,
  s as Container,
  x as Link,
  f as Message
};
